export default __webpack_public_path__ + "static/testimonial-pattern-orange-95ed106fe1f2c44878654346232e1f56.svg";